import React from "react";
import {
  setArchivedTask,
  setCompletingTask,
  setUnscheduledTask,
} from "schedule/actions";
import { ArchiveTaskModal } from "schedule/components/ArchiveTaskModal";
import { CompleteTaskModal } from "schedule/components/CompleteTaskModal";
import { UnscheduleTaskModal } from "schedule/components/UnscheduleTaskModal";
import { useStore as useScheduleStore } from "schedule/store";
import { setCreateTaskModalState } from "tasks/actions";
import { CreateTaskModal } from "tasks/components/CreateTaskModal";
import { useStore as useTasksStore } from "tasks/store";

export const GlobalModals = () => {
  const {
    dispatch: dispatchTasks,
    state: { createTaskModalState },
  } = useTasksStore();
  const {
    dispatch: dispatchSchedule,
    state: { archivedTaskId, completingTaskId, unscheduledTaskId },
  } = useScheduleStore();
  return (
    <>
      <ArchiveTaskModal
        isOpen={!!archivedTaskId}
        taskId={archivedTaskId}
        onClose={() => dispatchSchedule(setArchivedTask(""))}
      />
      <CompleteTaskModal
        isOpen={!!completingTaskId}
        taskId={completingTaskId}
        onClose={() => dispatchSchedule(setCompletingTask(""))}
      />
      <UnscheduleTaskModal
        isOpen={!!unscheduledTaskId}
        taskId={unscheduledTaskId}
        onClose={() => dispatchSchedule(setUnscheduledTask(""))}
      />
      <CreateTaskModal
        isOpen={createTaskModalState.isOpen}
        subjectId={createTaskModalState.subjectId}
        subjectType={createTaskModalState.subjectType}
        taskContextName={createTaskModalState.taskContextName}
        taskType={createTaskModalState.taskType}
        onClose={() =>
          dispatchTasks(setCreateTaskModalState({ isOpen: false }))
        }
      />
    </>
  );
};
